export default function (s) {
  this.id = s ? s.id : null;
  this.Codice = s ? s.Codice : null;
  this.Descrizione = s ? s.Descrizione : null;
  this.Tipo = s ? s.Tipo : null;
}